import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { NAV, SeriesButton } from "./Header";
import { Newsletter } from "./Newsletter";
import { useSite } from "@/context/SiteContext";

export const Footer = () => {
  const { settings } = useSite() || {};
  return (
    <footer className="bg-ink text-shell border-t-2 border-tang" data-testid="site-footer">
      <div className="container-mas py-14 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5 space-y-5">
          <p className="font-display text-3xl">MAS <span className="font-sans font-medium text-xl">Poetry & Literacy</span></p>
          <p className="text-shell/70 font-light max-w-sm">Free poetry, forever local. Keep the mic on.</p>
          <SeriesButton testid="footer-watch-mas-series-button" />
        </div>
        <div className="lg:col-span-3">
          <p className="eyebrow-dark mb-4">explore</p>
          <ol className="space-y-2.5">
            {[{ to: "/", label: "Home" }, ...NAV, { to: "/donate", label: "Donate & Donor Wall" }].map((n, i) => (
              <li key={n.to} className="flex gap-4"><span className="font-mono text-tang text-sm w-4">{i + 1}</span>
                <Link to={n.to} className="hover:text-tang transition-colors" data-testid={`footer-link-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{n.label}</Link></li>
            ))}
          </ol>
        </div>
        <div className="lg:col-span-4 space-y-4">
          <p className="eyebrow-dark">the newsletter</p>
          <p className="text-shell/70 text-sm font-light">Gatherings, workshops and Def Street news — straight to your inbox.</p>
          <Newsletter dark testid="footer-newsletter" />
        </div>
      </div>
      <div className="border-t border-tang/60">
        <div className="container-mas py-6 flex flex-wrap justify-center gap-x-10 gap-y-3 text-sm text-shell/80">
          <span className="font-semibold" data-testid="footer-org-name">MAS Arts Studio</span>
          {settings?.address && <span className="flex items-center gap-2" data-testid="footer-address"><MapPin className="w-4 h-4 text-tang" />{settings.address}</span>}
          {settings?.contact_email && <a href={`mailto:${settings.contact_email}`} className="flex items-center gap-2 hover:text-tang" data-testid="footer-contact-email"><Mail className="w-4 h-4 text-tang" />Contact Email: {settings.contact_email}</a>}
          {settings?.instagram_url && <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-tang" data-testid="footer-instagram-link"><Instagram className="w-4 h-4" />Instagram</a>}
          <span className="font-mono text-xs">© {new Date().getFullYear()} MAS Arts Studio</span>
          <Link to="/admin" className="font-mono text-xs hover:text-tang" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
